module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_delete_inline-9bb031735380e5d20d754b9262f856a5.png";